<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'mainComponent',
  };
</script>

<style lang="scss">@import "../scss/main.scss";</style>
